import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import Toggle from './toggle';
import ElementSettingsContext from '../helpers/element-settings-context';
import getBatchValues from '../helpers/get-batch-values';

function ToggleControl({ id, elementIds, targets, title, popover = null, onChange }) {
  const { resolvedState } = useContext(ElementSettingsContext);

  const flattenedValues = getBatchValues(resolvedState, { elementIds, targets }).flat();
  const isToggleEnabled = flattenedValues.every((value) => value !== false);

  const handleChange = useCallback(
    (value) => {
      onChange({ controlId: id, elementIds, targets, value });
    },
    [id, elementIds, targets, onChange]
  );

  return (
    <Toggle
      isToggleEnabled={isToggleEnabled}
      title={title}
      popover={popover}
      handleChange={handleChange}
    />
  );
}

ToggleControl.propTypes = {
  id: PropTypes.string.isRequired,
  elementIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  targets: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  popover: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imgSrc: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default ToggleControl;
